/** Progress-line labels for the service's tools. */
export const TOOL_LABELS: Record<string, string> = {
  find_participant: 'Looking up the participant',
  verify_caller_identity: 'Checking the identity answers',
  get_login_history: 'Reading login history',
  count_login_events: 'Tallying login events',
};

/** Shown in the error bubble. Pre-stream failures only; mid-stream ones carry their own text. */
export const ASSISTANT_ERRORS = {
  NO_RESPONSE: 'No response.',
  SESSION_REJECTED: 'The assistant rejected this session. Your sign-in may not have admin access to it.',
  UNREACHABLE: 'Could not reach the assistant service. Please try again in a moment.',
};
